<template>
	<div class="container-fluid">
		<div class="row vh-100">
			<div class="col-md-6 p-4">
				<div class="bg-secondary login-background rounded-4 d-flex flex-column justify-content-center align-items-center h-100 w-100">
					<div class="p-4">
						<h1>Hallo, Domains.</h1>
						<p>Information. Verwaltung. Dokumentation.</p>
					</div>
				</div>
			</div>
			<div class="login-column col-md-6 bg-white h-100 d-md-flex justify-content-center align-items-center">
				<div class="ps-1 pe-1 ms-auto me-auto w-100">
					<h2 class="mb-4">Anmelden</h2>
					<Form @submit="handleLogin" :validation-schema="schema">
						<div class="form-floating mb-3">
							<ErrorMessage name="username" class="error-feedback text-danger text-end end-0 top-0 mt-3 me-3 position-absolute" />
							<Field name="username" type="text" class="form-control" />
							<label for="username">Benutzer</label>
						</div>
						<div class="form-floating mb-3">
							<Field name="password" type="password" class="form-control" />
							<label for="password">Passwort</label>
							<ErrorMessage name="password" class="error-feedback text-danger text-end end-0 top-0 mt-3 me-3 position-absolute" />
						</div>

						<button class="btn btn-primary btn-lg w-100" :disabled="loading">
							<span v-show="loading" class="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
							<span>Anmelden</span>
						</button>

						<div class="form-group">
							<div v-if="message" class="alert alert-danger" role="alert">
								{{ message }}
							</div>
						</div>
					</Form>
					<p class="mt-4" style="font-size: 0.5rem;">Version 1.53.0</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';

export default {
	name: 'AppLogin',
	components: {
		Form,
		Field,
		ErrorMessage,
	},
	data() {
		const schema = yup.object().shape({
			username: yup.string().required('Pflichtfeld!'),
			password: yup.string().required('Pflichtfeld!'),
		});

		return {
			loading: false,
			message: '',
			schema,
		};
	},
	methods: {
		handleLogin(user) {
			this.loading = true;

			this.$store.dispatch('auth/login', user).then(
				() => {
					this.$store.dispatch('auth/fetchRoles');
					this.$store.dispatch('auth/fetchPreferences');

					this.$store.dispatch('typo3/fetchTypo3Versions');

					const startpagesPaths = this.$store.state.startpages.paths;
					const redirectPage = startpagesPaths[this.$store.state.auth.user.startpage];
					if (redirectPage) {
						this.$router.push(redirectPage);
					} else {
						this.$router.push('/technical');
					}

				},
				(error) => {
					this.loading = false;
					this.message = (error.response && error.response.data && error.response.data.error.message) || error.message || error.toString();
				}
			);
		},
	},
	computed: {
		loggedIn() {
			return this.$store.state.auth.status.loggedIn;
		},
	},
	created() {
		// If logged in redirect
		if (this.loggedIn) {
			const startpagesPaths = this.$store.state.startpages.paths;
			const redirectPage = startpagesPaths[this.$store.state.auth.user.startpage];
			if (redirectPage) {
				this.$router.push(redirectPage);
			} else {
				this.$router.push('/technical');
			}
		}
	},
	mounted() {
		this.$nextTick(() => {
			const input = document.querySelector('input[name="username"]');
			if (input && typeof input.focus === 'function') {
				input.focus();
			}
		});
	},
};
</script>

<style scoped>
@media (min-width: 991px) {
	.login-column>div {
		max-width: 400px;
	}
}

.login-background {
	background-color: hsla(165, 0%, 100%, 1);
	background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 962 962' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E"), radial-gradient(circle at 0% 0%, hsla(256, 82%, 77%, 0.35) 3.1210986267166043%, transparent 40%), radial-gradient(circle at 20% 0%, hsla(197, 77%, 74%, 0.35) 3.1210986267166043%, transparent 40%), radial-gradient(circle at 40% 0%, hsla(147, 77%, 74%, 0.35) 3.1210986267166043%, transparent 40%), radial-gradient(circle at 60% 0%, hsla(88, 77%, 74%, 0.35) 3.1210986267166043%, transparent 40%), radial-gradient(circle at 80% 0%, hsla(23, 77%, 74%, 0.35) 3.1210986267166043%, transparent 40%), radial-gradient(circle at 100% 0%, hsla(234.26470588235304, 100%, 50%, 0.35) 3%, transparent 40%);
	background-blend-mode: overlay, normal, normal, normal, normal, normal, normal;
}
</style>